export default {
  methods: {
    currentUser() {
      if (this.$store && this.$store.state && this.$store.state.currentUser) {
        return this.$store.state.currentUser;
      }
      throw new Error('invalid user session');
    }
  }
};
